import { Feeds, FeedsAction, FeedPayload } from "../interfaces/global-interfaces";

export default function feedsAction(feeds: FeedPayload[]) {
    return {
        type: FeedsAction.Update,
        payload: feeds
    } as Feeds;
}